import { render, staticRenderFns } from "./SchoolFindData.vue?vue&type=template&id=07d0d68e&scoped=true&"
import script from "./SchoolFindData.vue?vue&type=script&lang=js&"
export * from "./SchoolFindData.vue?vue&type=script&lang=js&"
import style0 from "./SchoolFindData.vue?vue&type=style&index=0&id=07d0d68e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0d68e",
  null
  
)

export default component.exports